import React from "react";
import { EditButton } from "react-admin";

export const CustomEditButton = (props) => {
    return (
        ((props.record && props.record.is_actual) ? <EditButton {...props} /> : null)
    )
}